import {syncService} from '../../../modules/admin/sync/syncService';

export const SYNC_ACTION_TYPES = {
  FETCH_STATS_REQUEST: 'SYNC/FETCH_STATS_REQUEST',
  FETCH_STATS_SUCCESS: 'SYNC/FETCH_STATS_SUCCESS',
  FETCH_STATS_FAILURE: 'SYNC/FETCH_STATS_FAILURE',

  FETCH_JOBS_REQUEST: 'SYNC/FETCH_JOBS_REQUEST',
  FETCH_JOBS_SUCCESS: 'SYNC/FETCH_JOBS_SUCCESS',
  FETCH_JOBS_FAILURE: 'SYNC/FETCH_JOBS_FAILURE',

  FETCH_JOB_DETAILS_REQUEST: 'SYNC/FETCH_JOB_DETAILS_REQUEST',
  FETCH_JOB_DETAILS_SUCCESS: 'SYNC/FETCH_JOB_DETAILS_SUCCESS',
  FETCH_JOB_DETAILS_FAILURE: 'SYNC/FETCH_JOB_DETAILS_FAILURE',

  START_SYNC_REQUEST: 'SYNC/START_SYNC_REQUEST',
  START_SYNC_SUCCESS: 'SYNC/START_SYNC_SUCCESS',
  START_SYNC_FAILURE: 'SYNC/START_SYNC_FAILURE',

  CLEAR_CURRENT_JOB: 'SYNC/CLEAR_CURRENT_JOB',
  CLEAR_ERROR: 'SYNC/CLEAR_ERROR',
};

const createRequestAction = (type, meta = {}) => ({
  type,
  meta,
});

const createSuccessAction = (type, payload) => ({
  type,
  payload,
});

const createFailureAction = (type, error) => ({
  type,
  payload: error,
});

export const fetchStats =
  (options = {}) =>
  async (dispatch) => {
    dispatch(
      createRequestAction(SYNC_ACTION_TYPES.FETCH_STATS_REQUEST, {
        background: options.background,
      }),
    );

  try {
    const response = await syncService.getStats();
    dispatch(
      createSuccessAction(SYNC_ACTION_TYPES.FETCH_STATS_SUCCESS, response.data),
    );
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch stats';
    dispatch(
      createFailureAction(SYNC_ACTION_TYPES.FETCH_STATS_FAILURE, errorMessage),
    );
  }
};

export const fetchJobs =
  (filter = {}, options = {}) =>
  async (dispatch) => {
    dispatch(
      createRequestAction(SYNC_ACTION_TYPES.FETCH_JOBS_REQUEST, {
        background: options.background,
      }),
    );

    try {
      const response = await syncService.getJobs(filter);
      dispatch(
        createSuccessAction(SYNC_ACTION_TYPES.FETCH_JOBS_SUCCESS, {
          jobs: response.data,
          filter,
        }),
      );
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        'Failed to fetch jobs';
      dispatch(
        createFailureAction(SYNC_ACTION_TYPES.FETCH_JOBS_FAILURE, errorMessage),
      );
    }
  };

export const fetchJobDetails = (jobId, options = {}) => async (dispatch) => {
  if (!jobId) {
    dispatch(
      createFailureAction(
        SYNC_ACTION_TYPES.FETCH_JOB_DETAILS_FAILURE,
        'Invalid job ID',
      ),
    );
    return;
  }

  dispatch(
    createRequestAction(SYNC_ACTION_TYPES.FETCH_JOB_DETAILS_REQUEST, {
      background: options.background,
    }),
  );

  try {
    const response = await syncService.getJobDetails(jobId);
    dispatch(
      createSuccessAction(
        SYNC_ACTION_TYPES.FETCH_JOB_DETAILS_SUCCESS,
        response.data,
      ),
    );
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch job details';
    dispatch(
      createFailureAction(
        SYNC_ACTION_TYPES.FETCH_JOB_DETAILS_FAILURE,
        errorMessage,
      ),
    );
  }
};

export const startSync = (request) => async (dispatch) => {
  dispatch(createRequestAction(SYNC_ACTION_TYPES.START_SYNC_REQUEST));

  try {
    const response = await syncService.startSync(request);
    dispatch(
      createSuccessAction(SYNC_ACTION_TYPES.START_SYNC_SUCCESS, response.data),
    );
    return response;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to start sync';
    dispatch(
      createFailureAction(SYNC_ACTION_TYPES.START_SYNC_FAILURE, errorMessage),
    );
    throw error;
  }
};

export const clearCurrentJob = () => ({
  type: SYNC_ACTION_TYPES.CLEAR_CURRENT_JOB,
});

export const clearError = () => ({
  type: SYNC_ACTION_TYPES.CLEAR_ERROR,
});
